const INSIGHTS_PROGRESS_PREFIX = 'insights_progress_v1';

export const getInsightsProgressKey = (userIdOrEmail, orgId) =>
  `${INSIGHTS_PROGRESS_PREFIX}:${String(userIdOrEmail || 'anon')}:${String(orgId || 'unknown')}`;

export const readInsightsProgress = (userIdOrEmail, orgId) => {
  if (typeof window === 'undefined') return { apps: 0, referrals: 0 };
  try {
    const raw = localStorage.getItem(getInsightsProgressKey(userIdOrEmail, orgId));
    const parsed = raw ? JSON.parse(raw) : {};
    const apps = Number(parsed?.apps || 0);
    const referrals = Number(parsed?.referrals || 0);
    return {
      apps: Number.isFinite(apps) ? Math.max(0, apps) : 0,
      referrals: Number.isFinite(referrals) ? Math.max(0, referrals) : 0,
    };
  } catch {
    return { apps: 0, referrals: 0 };
  }
};

export const incrementInsightsProgress = (userIdOrEmail, orgId, type) => {
  if (typeof window === 'undefined') return { apps: 0, referrals: 0 };
  const current = readInsightsProgress(userIdOrEmail, orgId);
  const next = {
    apps: type === 'apps' ? current.apps + 1 : current.apps,
    referrals: type === 'referrals' ? current.referrals + 1 : current.referrals,
  };
  try {
    localStorage.setItem(getInsightsProgressKey(userIdOrEmail, orgId), JSON.stringify(next));
  } catch {
    // ignore storage write errors
  }
  return next;
};
